import type { Merchant } from '@/types/fcc'

/** localStorage key holding a vendor name to use in place of the supplier's own. */
export const VENDOR_NAME_OVERRIDE_KEY = 'FCC_VENDOR_NAME_OVERRIDE'

/**
 * Dev-only. Outside production the FCC data and the NetSuite instance behind
 * the Workato recipe are not paired, so a real vendor name matches no NetSuite
 * vendor and Manage Settlements can only show its error state. Excluded from
 * sandbox and prod because this decides whose settlements get held; the MODE
 * check is substituted at build time, so the branch is eliminated there.
 */
const OVERRIDES_ENABLED =
  import.meta.env.MODE !== 'prod' && import.meta.env.MODE !== 'sandbox'

/** The override, or undefined when unset, blank, or not permitted here. */
export function vendorNameOverride(): string | undefined {
  if (!OVERRIDES_ENABLED) return undefined
  try {
    // A browser with site data blocked throws on read rather than returning null.
    return window.localStorage.getItem(VENDOR_NAME_OVERRIDE_KEY) || undefined
  } catch {
    return undefined
  }
}

/** The NetSuite vendor name to address: the override, else the supplier's own. */
export function resolveVendorName(
  merchant?: Pick<Merchant, 'ACCOUNTING_NAME'> | null,
): string | undefined {
  return vendorNameOverride() ?? merchant?.ACCOUNTING_NAME ?? undefined
}
